module.exports = __webpack_public_path__ + "static/media/winwin-winwin.f6321d21.mp3";